// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"cards_cardWrapper__130If"};